module.exports = __webpack_public_path__ + "img/portmone.dc217296.svg";